export default "__VITE_ASSET__CgYOvhCK__"